export default __webpack_public_path__ + "static/media/openLink.c68946c4.svg";